export default __webpack_public_path__ + "static/media/landscape9.a6031dd7.jpeg";